import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg, storeDelegatedToken } from "@/lib/api";

// Troca o código de uso único (gerado no painel do escritório) por uma sessão no sistema do cliente, só nesta aba.
export default function ContadorEntrar() {
  const { codigo } = useParams();
  const [erro, setErro] = useState("");
  const usado = useRef(false); // o código vale uma vez só: não chama duas vezes
  useEffect(() => {
    if (usado.current) return;
    usado.current = true;
    api.post(`/contabil/entrar/${codigo}`)
      .then(({ data }) => { storeDelegatedToken(data.token); window.location.replace("/app"); })
      .catch((e) => setErro(errMsg(e)));
  }, [codigo]);
  return (
    <div className="grid min-h-screen place-items-center p-6 text-center">
      {erro ? <div className="space-y-3"><p className="font-semibold">Não foi possível entrar no sistema do cliente</p><p className="text-sm text-muted-foreground">{erro}</p>
        <a href="/app/contabil" className="text-sm underline">Voltar ao painel do escritório</a></div>
        : <p className="text-sm text-muted-foreground"><Loader2 className="mr-2 inline h-4 w-4 animate-spin" />Abrindo o sistema do cliente…</p>}
    </div>
  );
}
